import { FunctionComponent } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import {
  CircleCheckSpan,
  CircularProgressContainer,
  NoPhotosAvailableDiv,
} from './image-button-grid.styles';
import { CircularProgress } from '@mui/material';
import { JNImage } from '../services';

interface ImageButtonGridProps {
  availableImages: Array<JNImage>;
  selectedImages: Array<string>;
  waitingForImages: boolean;
  onToggleSelect: any;
}

function CircleCheck(props) {
  if (props.selectedImages.some((e) => e.jnid === props.image.jnid)) {
    return (
      <CircleCheckSpan>
        <CheckIcon key={props.image.jnid} sx={{ color: 'white' }} />
      </CircleCheckSpan>
    );
  }

  return null;
}

function Content(props) {
  if (props.waitingForImages) {
    return (
      <CircularProgressContainer>
        <CircularProgress color="inherit" size={80} />
      </CircularProgressContainer>
    );
  }

  if (props.availableImages.length) {
    return (
      <ImageList
        data-e2e="image-grid"
        sx={{ width: 548, height: 410 }}
        cols={4}
        rowHeight={134}
      >
        {props.availableImages.map((image) => (
          <ImageListItem key={image.url}>
            <img
              loading="lazy"
              src={image.url}
              srcSet={`${image.url} 2x`}
              style={{ height: '134px', objectFit: 'contain', width: '134px' }}
              onClick={() => props.onToggleSelect(image)}
            />
            <CircleCheck image={image} selectedImages={props.selectedImages} />
          </ImageListItem>
        ))}
      </ImageList>
    );
  }

  return (
    <NoPhotosAvailableDiv>
      <h3>No photos available</h3>
      <h5>Add photos to the contact or job first</h5>
    </NoPhotosAvailableDiv>
  );
}

export const ImageButtonGrid: FunctionComponent<ImageButtonGridProps> = ({
  availableImages,
  selectedImages,
  waitingForImages,
  onToggleSelect,
}) => {
  return (
    <Content
      availableImages={availableImages}
      selectedImages={selectedImages}
      waitingForImages={waitingForImages}
      onToggleSelect={onToggleSelect}
    />
  );
};
